import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteTransaction from "../transactions/DeleteTransaction";
import UnnestChildTransaction from '../transactions/UnnestChildTransaction'



const UnnestChildTransactionAlert = (props) => {
    const { onCompletion, element, onClose } = props;

    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <UnnestChildTransaction onCompletion={onCompletion} element={element} onClose={onClose} />

        </Dialog >
    )

}

export default UnnestChildTransactionAlert;